export default [
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/Login/index"),
    meta: {
      public: true
    }
  },
  {
    path: "/verify",
    name: "verify",
    component: () => import("@/views/Login/Verify"),
    meta: {
      public: true
    }
  },
  {
    path: "/password",
    name: "password",
    component: () => import("@/views/Login/Password"),
    meta: {
      public: true
    }
  },
  {
    path: "/selectCompany",
    name: "selectCompany",
    component: () => import("@/views/Login/SelectCompany")
  },
  {
    path: "/createOrJoin",
    name: "createOrJoin",
    component: () => import("@/views/Login/CreateOrJoin")
  },
  {
    path: "/createCompany",
    name: "createCompany",
    component: () => import("@/views/Login/CreateCompany")
  },
  {
    path: "/joinCompany",
    name: "joinCompany",
    component: () => import("@/views/Login/JoinCompany")
  }
]
